// Libraries
var React = require("react");
var ReactDOMServer = require("react-dom/server");
var extend = require("lodash/extend");
var $ = require("jquery");

// Components
var GenericRichText = require('../RichText/GenericRichText');

// Styles
require("slick-carousel/slick/slick.css");
require("slick-carousel/slick/slick-theme.css");
require("./TestimonialCarousel.scss");

class TestimonialCarouselModule extends React.Component {
	constructor(props) {
		super(props);

		this.state = {
			name: this.props.data.items[0].name || "",
			preview: true,
		};

		const prefersReducedMotionMediaQuery = typeof window !== "undefined" ? window.matchMedia("(prefers-reduced-motion: reduce)") : false;

		this.baseSettings = {
			accessibility: true,
			initialSlide: 0,
			dots: true,
			draggable: true,
			swipe: true,
			touchMove: true,
			infinite: true,
			arrows: false,
			speed: 500,
			autoplay: true,
			autoplaySpeed: 3000,
			slidesToShow: 1,
			slidesToScroll: 1,
			prevArrow:
				'<button class="slick-prev slick-arrow" aria-label="Previous" type="button"><span class="u-visually-hidden">Previous</span></button>',
			nextArrow:
				'<button class="slick-next slick-arrow" aria-label="Next" type="button"><span class="u-visually-hidden">Next</span></button>',
		};

		if (!prefersReducedMotionMediaQuery || prefersReducedMotionMediaQuery.matches) {
			this.baseSettings.autoplay = false;
		} else {
			this.baseSettings.autoplay = true;
		}

		this.settings = null;
		this.mergeSettings(this.props.data.settings);
	}

	handlePrevClick = () => {
		if (this.gallery) {
			$(this.gallery).slick("slickPrev").slick('slickPause');
		}
	};
	handleNextClick = () => {
		if (this.gallery) {
			$(this.gallery).slick("slickNext").slick('slickPause');
		}
	};

	componentDidMount() {
		if (this.props.data.items.length <= 1) return;

		// this is here to prevent window being undefined when rendered server side
		require("slick-carousel");

		var gallery = $(this.gallery);
		gallery.not(".slick-initialized").slick(this.settings);

		gallery.on("beforeChange", (_event, _slick, _currentSlide, nextSlide) => {
			this.setState({
				name: this.props.data.items[nextSlide].name || "",
			});
		});

		const slickPrevButton = (
			<button
				className="slick-prev slick-arrow"
				aria-label="Previous"
				type="button"
				onClick={this.handlePrevClick}
			>
				<span className="u-visually-hidden">Previous</span>
			</button>
		);
		const slickNextButton = (
			<button
				className="slick-next slick-arrow"
				aria-label="Next"
				type="button"
				onClick={this.handleNextClick}
			>
				<span className="u-visually-hidden">Next</span>
			</button>
		);
		const slickPrevButtonHtml = ReactDOMServer.renderToString(slickPrevButton);
		const slickNextButtonHtml = ReactDOMServer.renderToString(slickNextButton);

		gallery
			.on(
				"click",
				".c-testimonial-carousel__pagination .slick-prev",
				this.handlePrevClick
			)
			.on(
				"click",
				".c-testimonial-carousel__pagination .slick-next",
				this.handleNextClick
			)
			.on("swipe", function() {
				gallery.slick("slickPause");
			})
			.find(".slick-dots")
			.wrap('<div class="c-testimonial-carousel__pagination"></div>')
			.before(slickPrevButtonHtml)
			.after(slickNextButtonHtml);

		gallery
			.find(".slick-dots").on("click", function(){
			gallery.slick("slickPause");
		  	})

	}
	mergeSettings(settings) {
		if (settings != null) {
			this.settings = extend(this.baseSettings, this.props.data.settings);
		} else {
			this.settings = this.baseSettings;
		}
	}
	componentDidUpdate(prevProps) {
		if (prevProps.data !== this.props.data) {
			this.mergeSettings(this.props.data);
		}
	}

	render() {
		const additionalTestimonanialClass = this.props.data.isOneHotspur ? ' c-section--one-hotspur' : '';

		return (
			<div className={`c-testimonial-carousel${additionalTestimonanialClass}`} id={this.props.data.id || null}>
				<div className="c-testimonial-carousel__wrapper">
					<div
						className="c-testimonial-carousel__wrapper-inner"
						ref={(g) => (this.gallery = g)}
					>
						{this.props.data.items.map((item, index) => (
							<div key={index} className="c-testimonial-carousel__slide">
								<div className="c-testimonial-carousel__slide__content">
									<div className="c-testimonial-carousel__quote">
										<GenericRichText content={item.testimonial} />
									</div>
									<p className="c-testimonial-carousel__caption">
										{item.name}<strong>{item.suffix ? `, ${item.suffix}` : ''}</strong>
									</p>
								</div>
							</div>
						))}
					</div>
					<div className="c-testimonial-carousel__background"></div>
				</div>
			</div>
		);
	}
}

module.exports = TestimonialCarouselModule;



// WEBPACK FOOTER //
// ./src/components/TestimonialCarousel/TestimonialCarouselModule.js